const PointsGoldSVG200 = () => {
  return (
    <svg
      fill="none"
      height="200"
      viewBox="0 0 201 200"
      width="201"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_168_28042)">
        <path
          d="M100.508 200.001C155.733 200.001 200.501 155.233 200.501 100.008C200.501 44.7839 155.733 0.015625 100.508 0.015625C45.2839 0.015625 0.515625 44.7839 0.515625 100.008C0.515625 155.233 45.2839 200.001 100.508 200.001Z"
          fill="#FFE876"
        />
        <path
          d="M153.77 15.3725C107.038 -14.0448 45.2937 -0.00211876 15.8764 46.7297C-13.5409 93.476 0.501787 155.206 47.2336 184.623L153.77 15.3725Z"
          fill="white"
          opacity="0.4"
        />
        <path
          d="M156.969 156.464C188.149 125.284 188.149 74.7316 156.969 43.5519C125.79 12.3721 75.2373 12.3721 44.0575 43.5519C12.8777 74.7316 12.8777 125.284 44.0575 156.464C75.2373 187.644 125.79 187.644 156.969 156.464Z"
          fill="#E6B54A"
        />
        <path
          d="M29.0471 100.011C29.0471 57.318 62.5469 22.4573 104.689 20.2857C103.3 20.2134 101.91 20.1699 100.491 20.1699C56.3942 20.1699 20.6504 55.9137 20.6504 100.011C20.6504 144.108 56.3942 179.851 100.491 179.851C101.895 179.851 103.3 179.808 104.689 179.736C62.5469 177.55 29.0471 142.689 29.0471 100.011Z"
          fill="#D19828"
        />
        <path
          clip-rule="evenodd"
          d="M66.5479 98.3577C66.5479 107.313 67.2306 122.313 84.8463 122.313L87.1431 109.978C80.4883 109.978 78.9868 107.619 78.9868 98.3129L78.6166 53.3594L66.1777 53.461L66.5479 98.3577ZM135.988 118.66V74.8497H123.549V101.208C123.149 107.498 118.914 110.621 113.864 110.621C108.208 110.621 104.89 106.96 104.89 100.281V74.8497H92.4961V104.286L92.5109 105.003C92.8352 115.343 100.196 122.306 110.399 122.306C115.389 122.306 120.276 120.707 123.549 116.165V118.675C123.562 124.592 121.209 129.284 116.944 131.869C112.428 134.603 106.579 134.544 101.277 131.705L95.4429 142.792C99.9875 145.227 104.846 146.439 109.585 146.439C114.425 146.439 119.166 145.168 123.356 142.627C131.397 137.741 136.002 129 135.988 118.66Z"
          fill="#FFF1AD"
          fill-rule="evenodd"
        />
        <path
          clip-rule="evenodd"
          d="M78.5352 121.912C80.375 122.436 82.4991 122.727 84.9513 122.727L87.2481 110.392C86.6927 110.392 86.1733 110.376 85.6875 110.34L78.5352 121.912ZM92.6011 99.1553V104.7L92.6159 105.417C92.9402 115.757 100.301 122.72 110.504 122.72C115.494 122.72 120.381 121.121 123.654 116.579V119.089C123.667 125.006 121.314 129.698 117.049 132.283C112.533 135.017 106.684 134.958 101.382 132.119L95.5479 143.206C100.093 145.641 104.951 146.853 109.69 146.853C114.53 146.853 119.271 145.582 123.461 143.041C131.502 138.155 136.107 129.414 136.093 119.074V75.2637H123.654V101.622C123.254 107.912 119.019 111.035 113.969 111.035C108.313 111.035 104.995 107.374 104.995 100.695V79.1031L92.6011 99.1553Z"
          fill="#FFE876"
          fill-rule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="clip0_168_28042">
          <rect fill="white" height="200" transform="translate(0.5)" width="200" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PointsGoldSVG200;
